export default __webpack_public_path__ + "static/media/professionalism.5aecb56e.jpg";